import { PropertyHelper } from '@/helpers/property.helper';
import { AlertService } from '@/services/alert.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { PropertiesManagementService, RealProperty } from '@eemo/api-client';

import { MatButtonModule } from '@angular/material/button';
import { InputTrimDirective } from '../../extensions/inputTrimDirective';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgIf, NgFor } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

export class PropertyCloneDialogData {
  prop: RealProperty;
}

@Component({
    selector: 'app-property-clone-dialog',
    templateUrl: './property-clone-dialog.component.html',
    styleUrls: ['./property-clone-dialog.component.scss'],
    standalone: true,
    imports: [MatDialogModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, NgIf, MatSlideToggleModule, NgFor, InputTrimDirective, MatButtonModule]
})
export class PropertyCloneDialogComponent implements OnInit {
  propertyCloneForm: UntypedFormGroup;
  formSubmitting = false;
  displayChildrenNames = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PropertyCloneDialogData,
    private propertiesMngtService: PropertiesManagementService,
    private fb: UntypedFormBuilder,
    private alertService: AlertService,
    public dialogRef: MatDialogRef<PropertyCloneDialogComponent>,
    public propHelper: PropertyHelper
  ) {}

  f(field: string): AbstractControl {
    return this.propertyCloneForm.get(field);
  }

  ngOnInit() {
    this.propertyCloneForm = this.fb.group({
      count: [1, [Validators.pattern('[0-9]*'), Validators.required]],
      withDocs: [false, [Validators.required]],
      withPhotos: [false, [Validators.required]],
      withChildren: [false, [Validators.required]],
      newNames: this.fb.array([])
    });

    this.addNewName(this.data.prop.name + ' copie 1');
    this.f('count').valueChanges.subscribe((val) => {
      if (val > this.newNames.length) {
        // add new if needed
        for (let i = this.newNames.length; i <= val; i++) {
          this.addNewName(this.data.prop.name + ' copie ' + (i + 1));
        }
      } else if (val < this.newNames.length) {
        // remove if needed
        for (let i = val; i <= this.newNames.length; i++) {
          this.newNames.removeAt(i);
        }
      }
    });
  }

  get newNames(): UntypedFormArray {
    return this.f('newNames') as UntypedFormArray;
  }

  addNewName(defaultName: string) {
    this.newNames.push(
      this.fb.group({
        name: [defaultName, [Validators.required, Validators.maxLength(50)]]
      })
    );
  }

  onSubmit() {
    if (this.propertyCloneForm.valid) {
      this.formSubmitting = true;

      let newNamesValues: string[] = null;
      if (this.displayChildrenNames) {
        newNamesValues = [];
        (this.newNames.value as any[]).forEach((obj) => newNamesValues.push(obj.name));
      }

      this.propertiesMngtService
        .cloneRealProperty(
          this.data.prop.uid,
          this.f('count').value,
          this.f('withDocs').value,
          this.f('withPhotos').value,
          this.f('withChildren').value,
          newNamesValues
        )
        .subscribe(
          (createdIds) => {
            this.dialogRef.close(createdIds);
            this.alertService.success('Créations effectuées avec succès');
          },
          (err: HttpErrorResponse) => {
            this.dialogRef.close();
          }
        );
    }
  }
  onNoClick(): void {
    this.dialogRef.close(false);
  }

  toggleDisplayChildrenNames() {
    this.displayChildrenNames = !this.displayChildrenNames;
  }
}
